<script>
    import LoadingSpinner from "./LoadingSpinner.svelte";
    import Overlay from "./Overlay.svelte";
    import Util from "../lib/util.js";

    export let show = true;
    export let global = true;
    export let loaderBackground;
    export let background;
    export let lightSpinner = false;

    $: _background = background || (global) ? "#fff" : "darken";

    const quotes = [
        {author: "John Stahl-Wert", text: "If you want to do something that really changes someone’s life, the best thing you can do is make the person you’re trying to help a participant in the process"}
        , {author: "Debasish Mridha", text: "Winning has a value for ego, but participation has value for life."}
        , {author: "Daniel Libeskind", text: "Life it is not just a series of calculations and a sum total of statistics, it’s about the experience, it’s about participation, it is something more complex and more interesting than what is obvious."}
        , {author: "Barack Obama", text: "The more we can encourage participation, I think the better off we are"}
        //, {author: "", text: ""}
    ];

    $: randomQuote = Util.randomItem(quotes);
</script>

<Overlay style="z-index: 999" class="modal-loading" background={_background} {loaderBackground} {global} {show} closable={false}>
    <span class="wrapper">
        <h1>Evalueaid</h1>
        <LoadingSpinner light={lightSpinner}/>
        {#if global}
            <blockquote>
                <span class="text">{randomQuote.text}</span>
                <span class="author">- {randomQuote.author}</span>
            </blockquote>
        {/if}
    </span>
</Overlay>

<style>
    @import url('https://fonts.googleapis.com/css2?family=Lily+Script+One&display=swap');

    h1 {
        color: #2cd533;
        color: #CCC;
    }

    blockquote {
        quotes: "\201C""\201D""\2018""\2019";
        font-style: italic;
        max-width: 300px;
        color: #CCC;
        margin-top: 30px;
        display: block;
    }

    blockquote:before {
      color: #ccc;
      content: open-quote;
      font-size: 5em;
      line-height: 0.1em;
      margin-right: 0.25em;
      vertical-align: -0.4em;
      font-family: 'Lily Script One', cursive;
    }

    .wrapper {
        text-align: center;
    }

    .text {
        font-family: 'Lily Script One', cursive;
        font-size: 20px;
        //text-shadow: 4px 4px 3px rgba(0,0,0,0.1);
    }

    .author {
        display: block;
        text-align: right;
        margin-top: 10px;
        font-style: italic;
        font-weight: bold;
    }
</style>